<script setup lang="ts">
import { computed } from 'vue'
import { Color } from '@previo/codebooks'
import PSpace from '../space/PSpace.vue'
import PIcon from '../icon/PIcon.vue'
import PTextStandard from '../typography/body/PTextStandard.vue'
import PTextDescription from '../typography/system/PTextDescription.vue'
import { PSpaceSize } from '../space/types'

type Props = {
  label: string
  placeholder?: null | string
  value?: null | string | number
  icon?: string
  color?: Color.GREY_300 | Color.GREY_600 | Color.POSITIVE | Color.NEGATIVE
}

const props = withDefaults(defineProps<Props>(), {
  color: Color.GREY_600,
})

const text = computed<string>(() => {
  return (props.value || props.placeholder || '').toString()
})

const isDisabled = computed<boolean>(() => {
  return !props.value
})
</script>

<template>
  <div>
    <div class="p-flex p-items-center">
      <template v-if="!!icon">
        <p-icon :icon="icon" />
        <p-space :mobile="PSpaceSize.XS" />
      </template>
      <p-text-description :text="label" :color="Color.GREY_500" />
    </div>

    <div class="p-flex-1">
      <slot name="default">
        <p-text-standard :text="text" :color="color" :class="{ disabled: isDisabled }" />
      </slot>
    </div>
  </div>
</template>
